(function () {
  'use strict';

  var ANCHOR_IDS = ['looxReviews', 'joga-product-reviews'];
  var MAX_ATTEMPTS = 50;
  var RETRY_MS = 100;

  function getScrollOffset() {
    var header =
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('header.header');
    var headerH = header ? header.getBoundingClientRect().height : 0;
    var announce = document.querySelector('.announcement-bar-section, .utility-bar');
    var announceH = announce ? announce.getBoundingClientRect().height : 0;
    var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var varH = cssVar ? parseFloat(cssVar) : 0;
    return Math.max(headerH + announceH, varH, 80) + 16;
  }

  function findReviewsTarget() {
    var i;
    var el;
    for (i = 0; i < ANCHOR_IDS.length; i++) {
      el = document.getElementById(ANCHOR_IDS[i]);
      if (el) return el;
    }
    el = document.querySelector(
      '[id^="shopify-section-"] [class*="loox"], [id^="shopify-section-"] [id*="loox_reviews"]'
    );
    if (el) {
      return el.closest('[id^="shopify-section-"]') || el;
    }
    return null;
  }

  function scrollToReviewsTarget(target) {
    var offset = getScrollOffset();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function scrollToReviews(attempt) {
    attempt = attempt || 0;
    var target = findReviewsTarget();
    if (target) {
      scrollToReviewsTarget(target);
      return;
    }
    if (attempt < MAX_ATTEMPTS) {
      setTimeout(function () {
        scrollToReviews(attempt + 1);
      }, RETRY_MS);
    }
  }

  function isReviewsLink(link) {
    if (!link || link.tagName !== 'A') return false;
    var href = (link.getAttribute('href') || '').trim();
    if (href === '#looxReviews' || href === '#joga-product-reviews') return true;
    if (link.classList.contains('pdp-metafield-rating')) return true;
    return !!link.closest(
      '.loox-rating, [class*="loox-rating"], [id*="loox_reviews_loox_rating"]'
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('a');
      if (!isReviewsLink(link)) return;
      e.preventDefault();
      scrollToReviews(0);
    },
    true
  );

  function onHashReviews() {
    if (location.hash === '#looxReviews' || location.hash === '#joga-product-reviews') {
      scrollToReviews(0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onHashReviews);
  } else {
    onHashReviews();
  }
  window.addEventListener('hashchange', onHashReviews);
})();
